<template>
  <div class="is-marginless is-paddingless section section-details" v-if="produit">
    <div class="entete">
      <div class="columns mgb-0">
        <div class="column pdb-0">
          <h1 class="title is-size-3">
            {{ $t('produitFace.title', { libelle: produit.libelle }) }}
            <b-tag v-if="!produit.actif"
              type="has-background-subMenu"
              class="has-text-white mgl-5px">
              {{$t('catalogue.etatProduit')}}
            </b-tag>
            <b-tag v-if="produit.produitFace.faceId && face"
              type="has-background-subMenu"
              class="has-text-white mgl-5px">
              {{ getEtatFace(face.etat) }}
            </b-tag>
          </h1>
        </div>
        <a ref="lienDownload"></a>
        <div class="column is-narrow pdb-0">
          <div class="is-pulled-right buttons boutonAction">
            <dropdownButton
                  type="is-addOrEdit"
                  class="mgr-2"
                  :permission="permCatalogue.maj"
                  :actions="actionSecondary"
                  @click="$router.push(getRouteEdit)">
                    {{ $t('detail.buttons.edit') }}&nbsp;
            </dropdownButton>
            <button class="button">
              <b-dropdown position="is-bottom-left" classs="has-text-left">
                <div slot="trigger">
                  <b-icon icon="file-download" type="is-default"></b-icon>
                  <b-icon icon="chevron-down"
                          class="has-text-secondary-icon">
                  </b-icon>
                </div>
                <b-dropdown-item
                  class="has-text-left"
                  @click="checkPermissions(permCatalogue.editer) ?
                    edition({
                      typeDonnee: typeDonneeEdition,
                      format: constantes.TYPE_PDF,
                      typeEdition: constantes.TYPE_EDITION_FACE_CATALOGUE,
                    }) : showPopUpPermission()">
                  {{ $t('general.popUpEdition.type.pdf') }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="checkPermissions(permCatalogue.editer) ?
                    edition({
                      typeDonnee: typeDonneeEdition,
                      format: constantes.TYPE_DOCX,
                      typeEdition: constantes.TYPE_EDITION_FACE_CATALOGUE,
                    }) : showPopUpPermission()">
                  {{ $t('general.popUpEdition.type.docx') }}
                </b-dropdown-item>
                <b-dropdown-item class="has-text-left" v-if="modulePresseActive"
                  @click="checkPermissions(permCatalogue.editer)
                  ? popUpEdition = true: showPopUpPermission()">
                  {{ $t('general.popUpEdition.type.other') }}
                </b-dropdown-item>
              </b-dropdown>
            </button>
            <piece-jointe-button
              :class="[{'button-access-no-permission' : produitWithHolding},
              { 'pointer-events-none' : produitWithHolding}]"
              class="mgr-2"
              :perm="permCatalogue.maj"
              autoSave>
            </piece-jointe-button>
            <button class="button">
              <b-dropdown position="is-bottom-left" class="has-text-left">
                <div slot="trigger">
                  <b-icon icon="call-split" type="is-default"></b-icon>
                  <b-icon icon="chevron-down" class="has-text-secondary-icon"></b-icon>
                </div>
                <b-dropdown-item class="pdl-20px">
                  <p class="has-text-icon-more is-size-7">
                    {{$t('catalogue.newProduct.titleAccesRapide')}}
                  </p>
                </b-dropdown-item>
                <b-dropdown-item
                                v-for="(accesRapide, index) in genererAllAccesRapide" :key="index"
                                :has-link="!accesRapide.disabled"
                                :disabled="accesRapide.disabled">
                  <span v-if="accesRapide.disabled" class="is-size-6">
                    {{accesRapide.libelle}}
                  </span>
                  <router-link-blank v-else
                                    :to="{ name: accesRapide.name,
                                        params: accesRapide.params}"
                                    classMessage="has-text-default is-size-6"
                                    classComposant="noTextDecoration"
                                    :message="accesRapide.libelle"/>
                </b-dropdown-item>
              </b-dropdown>
            </button>
          </div>
        </div>
      </div>
      <app-breadcrumb :breadcrumb="breadcrumb" />
      <div class="tab">
        <ul>
          <li @click="activeTab = 'AppProduit'"
              :class="{'is-active': activeTab === 'AppProduit'}">
            {{ $t('produitFace.onglet.produit')}}
          </li>
          <li @click="activeTab = 'AppProduitsAssocies'"
              :class="{'is-active': activeTab === 'AppProduitsAssocies'}">
            {{ $t('produitFace.onglet.productAssocie')}}
          </li>
          <li :class="{'is-active': activeTab === 'TabListeLignesCommande'}"
              @click="activeTab = 'TabListeLignesCommande'">
            {{ $t('catalogue.newProduct.tab.ventes') }}
          </li>
          <li :class="{'is-active': activeTab === 'disponibilite-par-jour'}"
              @click="activeTab = 'disponibilite-par-jour'">
            {{ $t('catalogue.newProduct.tab.dispo') }}
          </li>
          <li :class="{'is-active': activeTab === 'affectation'}"
              @click="activeTab = 'affectation'">
            {{ $t('catalogue.newProduct.tab.affectation') }}
          </li>
          <li :class="[
              {'is-active': activeTab === 'logistique'},
              {'is-disabled': !face || produitWithHolding}]"
              @click="allerLogistique" >
              <b-tooltip
                :label="$t('demandeLogistique.tooltip.accesCatalogue')"
                :active ="!face">
                {{ $t('catalogue.newProduct.tab.logistique') }}
              </b-tooltip>
          </li>
          <li :class="{'is-active': activeTab === 'ProduitConcessionnaire'}"
              @click="activeTab = 'ProduitConcessionnaire'"
              v-if="parametresInterne(constantes.PARAMETRES_INTERNE_KEYS.retrocessionAlfa.key)">
            {{ $t('catalogue.newProduct.tab.produitConcessionnaire') }}
          </li>
          <li :class="{'is-active': activeTab === 'reglesAchat'}"
              @click="activeTab = 'reglesAchat'"
              v-if="modulePresseActive">
            {{ $t('catalogue.newProduct.tab.regleAchat') }}
          </li>
          <li :class="{'is-active': activeTab === 'demandeInterventionType'}"
              @click="activeTab = 'demandeInterventionType'">
            {{ $t('catalogue.newProduct.tab.demandeInterventionType') }}
          </li>
          <li :class="{'is-active': activeTab === 'NomenclatureTechnique'}"
            @click="activeTab = 'NomenclatureTechnique'">
            {{ $t('nomenclatureTechnique.title') }}
          </li>
        </ul>
      </div>
    </div>
    <div class="columns">
      <div class="column is-10">
        <div v-if="produit">
          <component
            popUpName="dispoFace"
            :is="activeTab"
            :produit="produit"
            :face="face"
            :produitValue="produit.produitFace"
            :commissions="produit.commissionsVendeur"
            :permissions="permCatalogue"
            :item="produit.produitFace"
            :disabled="true"
            detail isDisabled
          />
        </div>
      </div>
      <div class="column is-2">
        <div class="sticky-20px">
          <information-create-update-user :data="userInfoData"></information-create-update-user>
        </div>
      </div>
    </div>

    <b-modal v-model="popUpArchivage"
             has-modal-card
             class="modal">
      <PopUpPrevention
        :messHeader="this.$t(baseTradArchiveComputed + '.title')"
        :cancel="this.$t(baseTradArchiveComputed + '.no')"
        :validate="this.$t(baseTradArchiveComputed + '.yes')"
        @no="popUpArchivage = false"
        @yes="archiverProduit"/>
    </b-modal>
    <b-modal v-model="popUpCopy" has-modal-card class="modal">
      <PopUpPrevention
        :messHeader="$t('catalogue.popUpPreventionCopy.message')"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.next')"
        @yes="copy"
        @no="popUpCopy = false"
      />
    </b-modal>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :error="{}"
        :choiceEdition="getChoicesEdition"
        :filtreDates="true"
        @editionChoose="edition">
      </pop-up-edition>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import dropdownButton from '@/components/general/button/dropdownButton';
import AppBreadcrumb from '@/components/general/breadcrumb';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import inProgress from '@/services/general/inProgress';
import AppProduit from '@/components/catalogue/detail/produitFace/c_produit';
import AppProduitsAssocies from '@/components/catalogue/produitGeneral/l_produitsAssocies';
import TabListeLignesCommande from '@/components/bodac/lignesCommande/tabListeLignesCommande';
import { get, archiver, copieAsync } from '@/api/produit/produitFace';
import { get as getProduitFace } from '@/api/gabed/face';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import messageErreur from '@/services/general/messageErreur';
import DisponibiliteParJour from '@/components/planning/c_disponibiliteParJour';
import PopUpPrevention from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';
import affectation from '@/components/catalogue/affectation/affectation';
import logistique from '@/components/catalogue/produitGeneral/logistique/logistique';
import { getAll as getAllDemandeLogistique } from '@/api/logistique/demandeLogistique/index';
import { siteHasHolding } from '@/services/general/holding';
import getAllTourneeLigne from '@/api/logistique/tourneeLigne';
import { TYPE_DOCX, TYPE_PDF } from '@/configuration/edition/editionConf';
import edition from '@/api/edition/index';
import { TYPE_EDITION_FACE, TYPE_EDITION_FACE_CATALOGUE } from '@/configuration/catalogue/produitConf';
import { SENS_VENTE } from '@/configuration/devisConf';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import traductionLibelleEtat from '@/services/devisCommandes/traductionLibelleEtat';
import ProduitConcessionnaire
  from '@/components/bodac/produit/produitConcessionnaire/detail/produitConcessionnaire';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import reglesAchat from '@/components/catalogue/produitGeneralPresse/edition/reglesAchat';
import { MATERIEL } from '@/configuration/gabed/emplacement/emplacementConf';
import popUpEdition from '@/components/factures/p_edition';
import { LISTE_CHOICE_EDITION_PARUTION } from '@/configuration/presse/parution/parutionConfig';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import demandeInterventionType from '@/components/catalogue/produitGeneral/demandeInterventionType/demandeInterventionType';
import NomenclatureTechnique from '@/components/commun/nomenclature/nomenclatureTechnique';
import InformationCreateUpdateUser from '@/components/general/informationCreateUpdateUser';
import getUserInfoData from '@/services/general/getUserInfoData';

const Attachments = createNamespacedHelpers('attachments');
const permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'c_detailProduitFace',
  components: {
    dropdownButton,
    AppBreadcrumb,
    AppProduit,
    AppProduitsAssocies,
    TabListeLignesCommande,
    DisponibiliteParJour,
    routerLinkBlank,
    PopUpPrevention,
    affectation,
    logistique,
    ProduitConcessionnaire,
    reglesAchat,
    popUpEdition,
    pieceJointeButton,
    demandeInterventionType,
    NomenclatureTechnique,
    InformationCreateUpdateUser,
  },
  data() {
    return {
      activeTab: 'AppProduit',
      produit: null,
      permCatalogue: CATALOGUE,
      face: null,
      popUpArchivage: false,
      popUpCopy: false,
      tourneeAffichageId: null,
      constantes: {
        TYPE_PDF,
        TYPE_DOCX,
        PARAMETRES_INTERNE_KEYS,
        TYPE_EDITION_FACE_CATALOGUE,
      },
      listeEtats: traductionLibelleEtat(this.$i18n, ETAT_DISPOSITIF_PUBLICITAIRE),
      popUpEdition: false,
    };
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...permissions.mapActions({
      showPopUpPermission: 'showPopup',
    }),
    async copy() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const retour = await copieAsync(this.produit.id, this.$t('catalogue.labelCopy'));
        messageSucces(this.$t('catalogue.popUpPreventionCopy.success'));
        loadingComponent.close();
        this.$router.push({
          name: 'm.bodac.catalogue-editionFace',
          params: { produitId: retour.data.result.id },
        });
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    async archiverProduit() {
      this.popUpArchivage = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await archiver(this.produit.id, this.produit.actif);
        messageSucces(this.$t(this.baseTradArchiveComputed + '.produitFaceArchiver'));
        loadingComponent.close();
        this.produit.actif = !this.produit.actif;
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async getAllDemandeLogistiqueAsync() {
      const param = {
        query: {
          produitIds: [this.produit.id],
          societeId: this.societeActiveId,
        },
      };
      const demandes = (await getAllDemandeLogistique(param)).data.result.items;
      if (demandes) {
        this.produit.demandesLogistique = demandes;
      }
    },
    async getTourneeAffichageId() {
      const param = {
        query: {
          faceIds: [this.produit.produitFace.faceId],
          societeId: this.societeActiveId,
        },
        skipCount: 0,
        MaxResultCount: 20,
      };
      const response = (await getAllTourneeLigne(param)).data.result.items;
      if (response.length) this.tourneeAffichageId = response[0].tournee.id;
    },
    allerLogistique() {
      if (this.face && this.produitWithHolding === false) {
        this.activeTab = 'logistique';
      }
    },
    async edition(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await edition({
          ids: [this.produit.id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: donnees.parametresAdditionnels,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    getEtatFace(codeEtat) {
      const etatFind = this.listeEtats.find((etat) => {
        return etat.value === codeEtat;
      });
      return etatFind ? etatFind.libellei18n : null;
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    getChoicesEdition() {
      return LISTE_CHOICE_EDITION_PARUTION.filter(choice => choice.tousProduits);
    },
    typeDonneeEdition() {
      return TYPE_EDITION_FACE;
    },
    baseTradArchiveComputed() {
      if (this.produit && this.produit.actif) return 'produitFace.archivage';
      return 'produitFace.desarchivage';
    },
    produitWithHolding() {
      return (siteHasHolding() && this.produit
        && this.produit.supportCommercial.societeId !== this.societeActiveId);
    },
    genererAllAccesRapide() {
      const accesRapides = [];
      if (this.face) {
        accesRapides.push({
          name: 'c.gabed.emplacement-face',
          params: {
            id: this.face.materiel.dispositif.emplacementId,
            idFace: this.face.id,
          },
          libelle: this.$t('catalogue.newProduct.seeEmplacement'),
        },
        {
          name: 'c.logistique.tournee_modele',
          params: { id: this.tourneeAffichageId },
          libelle: this.$t('catalogue.newProduct.voirListeAffichage'),
          disabled: !this.tourneeAffichageId,
        },
        {
          name: 'l.baux.contrat-by-materiel',
          params: { typePatrimoine: MATERIEL, patrimoineId: this.face.materiel.id },
          libelle: this.$t('catalogue.newProduct.voirBaux'),
        });
      }
      accesRapides.push(
        { name: 'l.bodac.commandes-liste-par-produit', params: { sens: SENS_VENTE, produitId: this.produit.id }, libelle: this.$t('catalogue.newProduct.voirCommandes') },
        { name: 'l.bodac.factures-par-produit', params: { sens: SENS_VENTE, produitId: this.produit.id }, libelle: this.$t('catalogue.newProduct.voirFactures') },
        { name: 'l.bodac.commandes-lignesCmd-par-produit', params: { sens: SENS_VENTE, produitId: this.produit.id }, libelle: this.$t('catalogue.newProduct.voirLignesCommande') },
      );
      return accesRapides;
    },
    breadcrumb() {
      if (this.$route.params.isFromListeProduitFace) {
        return [
          { title: this.$i18n.t('catalogue.racine'), route: this.$PAGE_DEFAULT, isActive: false },
          { title: this.$i18n.t('listeProduitFace.title'), route: { name: 'l.bodac.catalogue-face' }, isActive: false },
          { title: this.$i18n.t('produitFace.title', { libelle: this.produit.libelle }), route: { name: '' }, isActive: true },
        ];
      }
      return [
        { title: this.$i18n.t('catalogue.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('catalogue.titleProduit'), route: { name: 'l.bodac.catalogue' }, isActive: false },
        { title: this.$i18n.t('produitFace.title', { libelle: this.produit.libelle }), route: { name: 'c.bodac.catalogue-face' }, isActive: true },
      ];
    },
    getRouteEdit() {
      return {
        name: 'm.bodac.catalogue-editionFace',
        params: {
          produitId: this.$route.params.id,
          isFromListeProduitFace: this.$route.params.isFromListeProduitFace,
        },
      };
    },
    actionSecondary() {
      const actions = [
        {
          label: this.$t('detail.buttons.delete'),
          action: () => { this.inProgress(); },
          actionpermission: CATALOGUE.supprimer,
          order: 2,
        },
      ];

      if (!this.face) {
        actions.push(
          {
            label: this.$t(this.baseTradArchiveComputed + '.action'),
            action: () => { this.popUpArchivage = true; },
            actionpermission: CATALOGUE.supprimer,
            order: 1,
          },
        );
      }
      return actions;
    },
    userInfoData() {
      return getUserInfoData(this.produit, this.produit?.produitFace);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.retrocessionAlfa.key,
        PARAMETRES_INTERNE_KEYS.modulePresse.key,
      ]);
      await this.setAttachmentContext({ module: 'ProduitUnitaire' });
      if (this.$route.params.id) {
        await this.setAttachmentElementId({ id: this.$route.params.id });
        this.produit = (await get(this.$route.params.id)).data.result;
        if (this.produit.produitFace.faceId) {
          this.face = (await getProduitFace(this.produit.produitFace.faceId)).data.result;
          await this.getTourneeAffichageId();
        }
      }
      await this.getAllDemandeLogistiqueAsync();
      if (this.produit.produitFace.nomenclature) {
        this.produit.produitFace.nomenclature = JSON.parse(this.produit.produitFace.nomenclature);
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
    this.setInformationPage(this.$t('pageGeneral.detail', { item: this.produit.libelle }));
  },
};
</script>

<style scoped>

</style>
